export default __webpack_public_path__ + "static/icons-hd-cloud-infrastructure-f2e0a6b6907e1d2731eb3dbf0942bfbc.svg";